import audioManager, { getMusicLabel, getOrderedMusicKeys, type SoundId } from '../audio/engine.js';

/**
 * Typed facade over the ported procedural audio engine.
 * Design rule (carried over): SFX play ONLY in response to a player click.
 * Callers must only use `click*` functions from input handlers.
 */

let ready = false;

/** Must be called from a user gesture (browser autoplay rules). */
export function ensureAudio(): void {
  if (ready) return;
  audioManager.init();
  void audioManager.load();
  ready = true;
}

export function setSound(on: boolean): void {
  if (on) ensureAudio();
  if (ready) audioManager.setEnabled(on);
}

export function soundOn(): boolean {
  return ready && audioManager.isEnabled();
}

export function clickSfx(id: SoundId): void {
  if (ready) audioManager.play(id);
}

export function clickCrow(breed: string): void {
  if (ready) audioManager.playCrow(breed);
}

export function clickCluck(breed: string): void {
  if (ready) audioManager.playHenCluck(breed);
}

export function clickRoosterCluck(breed: string): void {
  if (ready) audioManager.playRoosterCluck(breed);
}

export const audioSettings = {
  themes: () => audioManager.getThemeNames(),
  theme: () => audioManager.getTheme(),
  setTheme: (t: string) => audioManager.setTheme(t),
  musicKeys: () => getOrderedMusicKeys(),
  musicLabel: (k: string) => getMusicLabel(k),
  music: () => audioManager.getMusic(),
  setMusic: (k: string) => audioManager.setMusic(k),
  musicMode: () => audioManager.getMusicMode(),
  setMusicMode: (m: 'random' | 'specific') => audioManager.setMusicMode(m),
  shuffle: () => audioManager.shuffleMusic(),
  master: () => audioManager.getMasterVolume(),
  setMaster: (v: number) => audioManager.setMasterVolume(v),
  sfx: () => audioManager.getSfxVolume(),
  setSfx: (v: number) => audioManager.setSfxVolume(v),
  music_: () => audioManager.getAmbientVolume(),
  setMusicVolume: (v: number) => audioManager.setAmbientVolume(v),
  isReady: () => ready,
};
